import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.concat.js";
import React from 'react';
import { ChevronRight } from '@finect/tabular-icons/chevronRight';
import { TextButton } from '@finect/tabular-core/TextButton';
import { Trash2 } from '@finect/tabular-icons/trash2';
import { DateLabel } from '../../../DateLabel';
import { Content, Inner, Title, DateBlock, LineContent, LineActions } from './partials';
export var UserComparisonLine = function UserComparisonLine(_ref) {
  var session = _ref.session,
    _onClick = _ref.onClick,
    onDelete = _ref.onDelete;
  var plural = 'fondos de inversión';
  var date = session.created;
  var fundsField = session.items.find(function (item) {
    return item.field === 'products';
  });
  var titleField = session.items.find(function (item) {
    return item.field === 'productsCompared';
  });
  var fundsIDs = fundsField ? fundsField.value : [];
  var title = titleField ? titleField.value : null;
  var displayTitle = title || String("Comparaci\xF3n de ".concat(fundsIDs.length, " ").concat(plural));
  return React.createElement(Content, null, React.createElement(Inner, {
    onClick: function onClick() {
      return _onClick && _onClick(session);
    }
  }, React.createElement(LineContent, null, React.createElement(Title, null, displayTitle), React.createElement(DateBlock, null, React.createElement(DateLabel, {
    date: new Date(date),
    format: "timeSince"
  }))), React.createElement(LineActions, null, React.createElement(ChevronRight, null))), React.createElement(LineActions, null, onDelete && React.createElement(TextButton, {
    onClick: function onClick() {
      return onDelete(session);
    }
  }, React.createElement(Trash2, {
    size: 24,
    color: "#d0021b"
  }))));
};